export default (scoreboard) => scoreboard?.cal;
